import { action, ActionType } from "typesafe-actions";
import { BasicResourceType } from "../../../types/resources/resources.enums";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { SearchResults } from "../../../types/search/search-results.interface";
import { IProductHistory } from "../types/product-history.interface";

export enum ProductHistoryActions {
  ProductHistoryClear = "ProductHistory/Clear",

  ProductHistoryFetch = "ProductHistory/Fetch",
  ProductHistoryFetchFailure = "ProductHistory/FetchFailure",
  ProductHistoryFetchSuccess = "ProductHistory/FetchSuccess",

  ProductHistoryNext = "ProductHistory/Next",
  ProductHistoryNextFailure = "ProductHistory/NextFailure",
  ProductHistoryNextSuccess = "ProductHistory/NextSuccess",
}

export const clear = () => action(ProductHistoryActions.ProductHistoryClear);

export const fetch = (resourceType: BasicResourceType, resourceId: number) =>
  action(ProductHistoryActions.ProductHistoryFetch, { resourceType, resourceId });
export const fetchFailure = (error: IError) =>
  action(ProductHistoryActions.ProductHistoryFetchFailure, error);
export const fetchSuccess = (results: SearchResults<IProductHistory>) =>
  action(ProductHistoryActions.ProductHistoryFetchSuccess, results);

export const next = (url: string) => action(ProductHistoryActions.ProductHistoryNext, url);
export const nextFailure = (error: IError) =>
  action(ProductHistoryActions.ProductHistoryNextFailure, error);
export const nextSuccess = (results: SearchResults<IProductHistory>) =>
  action(ProductHistoryActions.ProductHistoryNextSuccess, results);

const actionCreators = {
  clear,

  fetch,
  fetchFailure,
  fetchSuccess,

  next,
  nextFailure,
  nextSuccess,
};

export type ProductHistoryActionsType = ActionType<typeof actionCreators>;
